import ops from '@/assets/js/vuescrollOption';
import User from "@/assets/images/person.png";
import {getScoreInfo, getFiveScoreInfo, uploadScore} from "@/api/training_teacher/api";
import {operationMsgSave} from "@/api/common/api";
import {storageData} from "@/assets/js/storage";
import {showScoreStatus} from "@/assets/js/status";
let {values} = Object;
const role_type=storageData.getUserType();
export default {
  data() {
    /*const uploadErr = {
      tips: "成绩填写不完整，请填写完整！",
      num: 0
    };*/
    const backWarn = {
      flag: false,
      tips: "确定放弃修改并返回吗？"
    };
    const uploadWarn = {
      flag: false,
      tips: role_type === 'teacher' ? "确定暂时保存吗？" : "确定保存吗？"
    };
    const nextWarn = {
      flag: false,
      tips: "确定保存，并进入下一步吗?"
    };
    const submitUploadEducationWarn = {
      flag: false,
      tips: "确定提交成绩吗?"
    };
    return {
      c_id: this.$route.query.c_id,
      role_type:role_type,
      ops: ops(),
      examObj:{},
      commonStuList:[],
      fail:0,
      User,
      classInfo: {},
      showList: false,
      student_status:true,
      formVal: [],
      // uploadErr,
      backWarn,
      uploadWarn,
      submitUploadEducationWarn,
      nextWarn,
      note: "如有备注，可在此输入。",
      repeatSubmit: false,
      showTotal: false,
      passNum: 0,
      oral_make_up: 0,
      theory_make_up: 0,
      practice_make_up: 0,
      semi_pass: 0,
      disScrollOpt: ops(true),
      showPreScore: false,
      ifDiaShow: false,
      stuUid: "",
      loading: false,
      l1Num: 0,
      activeExam: 0,
      onlyEarly: 0,
    };
  },
  filters: {
    getGender(gender) {
      return gender === "Male" ? "男" : "女";
    },
    showScore(status){
      return showScoreStatus(status);
    },
    preScore(val) {
      let result = "--";
      val !== "" && (result = val);
      return result;
    },
    tipMsg(student_information,is_restrict_stu_info,notNotes){
      let msg ="";
      if(student_information === 'verify' && is_restrict_stu_info === 0){
        msg ="该学员没有激活学员帐户，无法录入成绩。";
      }else if (notNotes){
        msg ="该学员没有提交课堂笔记，无法录入成绩。";
      }
      return msg;
    }
  },
  components: {
    "score-main": () => import("@/components/LayOut/Common/up-down"),
    "yioks-tips": () => import("@/components/Tips/Dialog"),
    "score-input": () => import("@/components/score/components/score-input"),
    "stu-detail-info": () => import("@/components/StuDeatilInfo/student-info"),
  },
  created() {
    this.getStusList();
  },
  methods: {
    getStusList() {
      getScoreInfo({c_id: this.c_id})
        .then(({data})=>{
          if(Number(data.status) === 0) {
            const {class_info, student_data, score_data, achievement_detail_data, achievementSubject} = data.result;
            this.classInfo = class_info;
            let examList=[],a=0;
            let examObj={};
            if(score_data.length > 0){ // 编辑
              let scoreArr = [];
              this.formVal = score_data.map((item, index) => {
                if(item.enroll_type === 'make_up_exam' || item.enroll_type === 'physical_make_up_exam' || item.enroll_type === 'semi_pass_make_up'){
                  examList.push(index);
                  examObj[index] = ++a;
                }
                scoreArr = [];
                if(achievement_detail_data.length > 0){
                  achievement_detail_data.map((e) => {
                    var pushItem = {
                      ...e,
                      err:false
                    };
                    if(item.achievement_id === e.achievement_id){
                      if((item.student_information === 'verify' && this.classInfo.is_restrict_stu_info === 0) || item.notNotes){
                          // 注意，这里没有合适的title匹配踢球能力等字符串，添加对应id，来匹配数据，注意踢球能力A，C，D，似乎都有，
                        // 注意：L1的踢球能力 不是选的了  是打分制了，所以这里 给ACD里面的踢球能力id写上，不能在写踢球能力了
                        // 还有一个 继续教育的教案考核
                        if([30, 45, 46, 54,67,68,69,73,78,83].includes(pushItem.achievement_subject_id)){
                          pushItem.achievement_score = "一般";
                        }else if([88,89].includes(pushItem.achievement_subject_id)){
                          pushItem.achievement_score = "否";
                        }else if([200].includes(pushItem.achievement_subject_id)){
                          pushItem.achievement_score = "差";
                        }else{
                          pushItem.achievement_score = "0";
                        }
                      }else{
                       //如果是教案考试  还没有教案 就是差
                        if(pushItem.achievement_subject_id === 200 && !item.plan_id){
                          pushItem.achievement_score = "差";
                        }
                      }
                      
                      scoreArr.push(pushItem);
                    }
                  });
                }
                return {
                  uid:item.uid,
                  user_id:item.stu_id,
                  user_name:item.user_name,
                  id_number:item.id_number,
                  plan_id:item.plan_id,
                  is_fail: item.is_fail,
                  practice_avg_points:item.practice_avg_points,
                  gender:item.gender,
                  enroll_type:item.enroll_type,
                  mobile_phone:item.mobile_phone,
                  user_img:item.profile_picture,
                  
                  remark: item.enroll_type === 'continue_education'
                    ? (item.is_fail === 1 ? "该学员没有提交考试教案" : item.ability_remark)
                    : (item.student_information === 'verify' && this.classInfo.is_restrict_stu_info === 0 ? "该学员没有激活学员帐户，无法录入成绩。" : item.notNotes ? "该学员没有提交课堂笔记，无法录入成绩。" : item.ability_remark),
                  results_status:item.enroll_type === 'continue_education' ? (item.is_fail === 1 ? "fail" : item.results_status) : ((item.student_information === 'verify' && this.classInfo.is_restrict_stu_info === 0) || item.notNotes ? "fail" : item.results_status),
                  results_level: (item.student_information === 'verify' && this.classInfo.is_restrict_stu_info === 0) || item.notNotes ? "" : item.results_level,
                  total_points:item.enroll_type === 'continue_education' ? (item.is_fail === 1 ? "0" : item.total_points) : ((item.student_information === 'verify' && this.classInfo.is_restrict_stu_info === 0) || item.notNotes ? "0" : item.total_points),
                  student_information:item.student_information,
                  notNotes:item.notNotes ? 1 : 0,
                  scoreArr
                };
              });
            } else { // 上传
              this.formVal = student_data.map((item,index)=>{
                let arr=[];
                if (item.enroll_type==='common' || item.enroll_type==='physical_train' || item.enroll_type==='goalkeeper_train'){
                  achievementSubject.map((e)=>{
                    if (e.achievement_subject_id !== 37 && e.achievement_subject_id !==44 && e.achievement_subject_id !==53 && e.achievement_subject_id !==204 && e.achievement_subject_id !==74 && e.achievement_subject_id !==79 && e.achievement_subject_id !==84 && e.achievement_subject_id !==130 && e.achievement_subject_id !==131 && e.achievement_subject_id !==132 && e.achievement_subject_id !==133){
                      arr.push({
                        ...e,
                        achievement_subject_des: e.achievement_subject_title + e.achievement_subject_des,
                        achievement_score: (item.student_information === 'verify' && this.classInfo.is_restrict_stu_info === 0) || item.notNotes ? ![30, 45, 46, 54,200,67,68,69,73,78,83].includes(e.achievement_subject_id)  ?  [88,89].includes(e.achievement_subject_id) ? "否" : "0" : "一般" : "",
                        err: false
                      })
                    }
                    return e
                  })
                }else if(item.enroll_type==='make_up_exam' || item.enroll_type === 'physical_make_up_exam'){
                  examList.push(index)
                  examObj[index]=++a;
                  achievementSubject.map((e)=>{
                    if (e.achievement_subject_id === 37 || e.achievement_subject_id ===44 || e.achievement_subject_id ===53|| e.achievement_subject_id ===204|| e.achievement_subject_id ===74 || e.achievement_subject_id ===79 || e.achievement_subject_id ===84){
                      arr.push({
                        ...e,
                        achievement_subject_des: e.achievement_subject_title + e.achievement_subject_des,
                        achievement_score: (item.student_information === 'verify' && this.classInfo.is_restrict_stu_info === 0) || item.notNotes ? ![30, 45, 46, 54,200,67,68,69,73,78,83].includes(e.achievement_subject_id) ?  [88,89].includes(e.achievement_subject_id) ? "否" : "0" : "一般" : "",
                        err: false
                      })
                    }
                    return e
                  })
                }else if(item.enroll_type === 'semi_pass_make_up'){
                  examList.push(index)
                  examObj[index]=++a;
                  achievementSubject.map((e)=>{
                    if (e.achievement_subject_id ===130 || e.achievement_subject_id ===131 || e.achievement_subject_id ===132 || e.achievement_subject_id ===133){
                      arr.push({
                        ...e,
                        achievement_subject_des: e.achievement_subject_title + e.achievement_subject_des,
                        achievement_score: (item.student_information === 'verify' && this.classInfo.is_restrict_stu_info === 0) || item.notNotes ? ![119].includes(e.achievement_subject_id) ? "0" : "一般" : "",
                        err: false
                      })
                    }
                    return e
                  })
                }else if(this.isFive && item.enroll_type==='') {
                  // 单独处理五人制
                  achievementSubject.forEach(e => {
                    if (e.achievement_subject_id !==130 && e.achievement_subject_id !==131 && e.achievement_subject_id !==132 && e.achievement_subject_id !==133){
                      arr.push({
                        ...e,
                        achievement_subject_des: e.achievement_subject_title + e.achievement_subject_des,
                        achievement_score: item.student_information === 'verify' && this.classInfo.is_restrict_stu_info === 0 ? ![30, 45, 46, 54,200,67,68,69,73,78,83].includes(e.achievement_subject_id) ? "0" : "一般" : "",
                        err: false
                      })
                    }
                    
                  })
                }else if(item.enroll_type==='continue_education') { // 继续教育
                  // 单独处理继续教育
                  achievementSubject.forEach(e => {
                    arr.push({
                      ...e,
                      achievement_subject_des: e.achievement_subject_title + e.achievement_subject_des,
                      achievement_score:  e.achievement_subject_id === 200 && !item.plan_id ? "差" : "",
                      err: false
                    })
                  })
                }else{
                  // 是一人之D、C
                  achievementSubject.map((e)=>{
                      arr.push({
                        ...e,
                        achievement_subject_des: e.achievement_subject_title + e.achievement_subject_des,
                        achievement_score: (item.student_information === 'verify' && this.classInfo.is_restrict_stu_info === 0) || item.notNotes
                          ? ![30, 45, 46, 54,200,67,68,69,73,78,83].includes(e.achievement_subject_id) ?  [88,89].includes(e.achievement_subject_id) ? "否" : "0" : "一般" : "",
                        err: false
                      })
                    return e
                  })
                }
                return {
                  uid: item.uid,
                  user_id:item.user_id,
                  user_name: item.user_name,
                  id_number: item.id_number,
                  gender: item.gender,
                  plan_id: item.plan_id,
                  is_fail: item.is_fail,
                  practice_avg_points:'',
                  enroll_type:item.enroll_type,
                  mobile_phone: item.mobile_phone,
                  user_img: item.user_profile_picture,
                  student_information: item.student_information,
                  notNotes: item.notNotes ? 1 : 0,
                  remark: item.enroll_type === 'continue_education'
                    ? (item.is_fail === 1 ? "该学员没有提交考试教案" : "")
                    : (item.student_information === 'verify' && this.classInfo.is_restrict_stu_info === 0 ? "该学员没有激活学员帐户，无法录入成绩。" : item.notNotes ? "该学员没有提交课堂笔记，无法录入成绩。" :  ""),
                  results_status: item.enroll_type === 'continue_education' ? (item.is_fail === 1 ? "fail" : "") : ((item.student_information === 'verify' && this.classInfo.is_restrict_stu_info === 0 ) || item.notNotes ? "fail" : ""),
                  total_points: item.enroll_type === 'continue_education' ? (item.is_fail === 1 ? "0" : "") : ((item.student_information === 'verify' && this.classInfo.is_restrict_stu_info === 0) || item.notNotes ? "0":""),
                  scoreArr: JSON.parse(JSON.stringify(arr))
                };
              });
            }
            if (examList.length>0){
              this.$set(this.formVal[examList[0]],'border',true);
              this.$set(this.formVal[Number(examList[0])],'showTotal',true);
              this.examObj=examObj;
            }else{
              this.$set(this.formVal[this.formVal.length - 1 ],'showTotal',true);
            }
            
            
            this.getResult();
            this.showList = true;
          }
        })
        .catch((err)=>{
          console.error(err);
        });
    },
    getScore(idx) {
      switch (this.classInfo.class_level) {
        case "C":
          this.levelCScore(idx);
          break;
        case "D":
          this.levelDScore(idx);
          break;
        case "B":
          this.levelBScore(idx);
          break;
        case "A":
          this.levelAScore(idx);
          break;
        case "PRO":
          this.levelPROScore(idx);
          break;
        case 'early':
          this.levelEarlyScore(idx);
          break;
        case 'L1':
          this.levelL1Score(idx);
          break;
        case 'L2':
          this.levelL2Score(idx);
          break;
        case 'L3':
          this.levelL3Score(idx);
          break;
        case 'F1':
          this.levelF1Score(idx);
          break;
        case 'F2':
          this.levelF2Score(idx);
          break;
        case 'GC':
          this.levelGCScore(idx);
          break;
        case 'GB':
          this.levelGBScore(idx);
          break;
        case 'GA':
          this.levelGAScore(idx);
          break;
        default:
          this.levelScoreOther(idx);
          break;
      }
      this.getResult();
    },
    getScoreEducation(idx) {
      this.levelScoreEducation(idx);
      this.getResult();
    },
    levelPROScore(idx) {
      const item = this.formVal[idx];
      const arr = this.formVal[idx].scoreArr;
      let exam1, exam2, exam3, theory, theory1, oral,maek_up_exam,zuoye,lunwen;
      arr.map((item) => {
        if (item.achievement_subject_des.includes("实践考试一")) {
          exam1 = Number(item.achievement_score);
        }
        if (item.achievement_subject_des.includes("实践考试二")) {
          exam2 = Number(item.achievement_score);
        }
        if (item.achievement_subject_des.includes("实践考试三")) {
          exam3 = Number(item.achievement_score);
        }
        if (item.achievement_subject_des.includes("一般理论考试")) {
          theory = Number(item.achievement_score);
        }
        if (item.achievement_subject_des.includes("专项理论考试")) {
          theory1 = Number(item.achievement_score);
        }
        if (item.achievement_subject_des.includes("比赛分析考试")) {
          oral = Number(item.achievement_score);
        }
        if (item.achievement_subject_des.includes("作业考试")) {
          zuoye = Number(item.achievement_score);
        }
        if (item.achievement_subject_des.includes("论文考试")) {
          lunwen = Number(item.achievement_score);
        }
        if (item.achievement_subject_des.includes("实践考核补考成绩")) {
          maek_up_exam = Number(item.achievement_score);
        }
      });
      const all_empty = arr.every((v) => {
        return v.achievement_score === "";
      });
      if (all_empty) {
        this.$set(item, "results_status", "");
      }
      else if (maek_up_exam){
        if (maek_up_exam ===70){
          this.$set(this.formVal[idx], "results_status", "pass");
        }else{
          this.$set(this.formVal[idx], "results_status", "fail");
        }
      } else{
//        if (exam1 || exam2 || exam3 || theory || theory1 || oral){
//          let average= ((exam1 + exam2 + exam3 + theory + theory1 +oral ) / 6 ).toFixed(2);
//          this.$set(this.formVal[idx], "practice_avg_points", average);
//        }else{
//          this.$set(this.formVal[idx], "practice_avg_points", '');
//        }
        let tempArr = [exam1, exam2, exam3].filter((i) => {
          return i >= 70;
        });
        let tempArr1 = [exam1, exam2, exam3].filter((i) => {
          return i >= 42;
        });
        let tempArr2=[theory, theory1,oral,zuoye,lunwen].filter((i) =>{
          return i >= 60
        });
        if (tempArr.length >= 2 && tempArr2.length === 5 &&  tempArr1.length === 3) {
          this.$set(this.formVal[idx], "results_status", "pass");
        } else {
          if (tempArr2.length!==5){
            this.$set(this.formVal[idx], "results_status", "fail");
          }
          else if (tempArr1.length >= 2 && tempArr.length>=1){
            this.$set(this.formVal[idx], "results_status", "practice_make_up");
          } else{
            this.$set(this.formVal[idx], "results_status", "fail");
          }
        }
      }
    },
    levelAScore(idx) {
      const item = this.formVal[idx];
      const arr = this.formVal[idx].scoreArr;
      let score = 0;
      let exam1, exam2, exam3, theory, theory1, oral,maek_up_exam,zuoye;
      arr.map((item) => {
        if (item.achievement_subject_des.includes("实践考试一")) {
          exam1 = Number(item.achievement_score);
          score += item.achievement_score * item.achievement_subject_weight;
        }
        if (item.achievement_subject_des.includes("实践考试二")) {
          exam2 = Number(item.achievement_score);
          score += item.achievement_score * item.achievement_subject_weight;
        }
        if (item.achievement_subject_des.includes("实践考试三")) {
          exam3 = Number(item.achievement_score);
          score += item.achievement_score * item.achievement_subject_weight;
        }
        if (item.achievement_subject_des.includes("一般理论考试")) {
          theory = Number(item.achievement_score);
          score += item.achievement_score * item.achievement_subject_weight;
        }
        if (item.achievement_subject_des.includes("专项理论考试")) {
          theory1 = Number(item.achievement_score);
          score += item.achievement_score * item.achievement_subject_weight;
        }
        if (item.achievement_subject_des.includes("比赛分析考试")) {
          oral = Number(item.achievement_score);
          score += item.achievement_score * item.achievement_subject_weight;
        }
        if (item.achievement_subject_des.includes("作业考试")) {
          zuoye = Number(item.achievement_score);
          score += item.achievement_score * item.achievement_subject_weight;
        }
        if (item.achievement_subject_des.includes("实践考核补考成绩")) {
          maek_up_exam = Number(item.achievement_score);
        }
      });
      const all_empty = arr.every((v) => {
        return v.achievement_score === "";
      });
      if (all_empty) {
        this.$set(item, "results_status", "");
      }
      else if (maek_up_exam){
        if (maek_up_exam ===70){
          this.$set(this.formVal[idx], "results_status", "pass");
        }else{
          this.$set(this.formVal[idx], "results_status", "fail");
        }
      } else{
        if (exam1 || exam2 || exam3 || theory || theory1 || oral || zuoye){
          score = score / 100;
          let average= score.toFixed(2);// 2023.02.27修改，保留两个小数
          this.$set(this.formVal[idx], "practice_avg_points", average);
        }else{
          this.$set(this.formVal[idx], "practice_avg_points", '');
        }
        let tempArr = [exam1, exam2, exam3].filter((i) => {
          return i >= 70;
        });
        let tempArr1 = [exam1, exam2, exam3].filter((i) => {
          return i >= 42;
        });
        let tempArr2=[theory, theory1,oral,zuoye].filter((i) =>{
          return i >= 60
        });
        if (tempArr.length >= 2 && tempArr2.length === 4 &&  tempArr1.length === 3) {
          this.$set(this.formVal[idx], "results_status", "pass");
        } else {
          if (tempArr2.length!==4){
            this.$set(this.formVal[idx], "results_status", "fail");
          }
          else if (tempArr1.length >= 2 && tempArr.length>=1){
            this.$set(this.formVal[idx], "results_status", "practice_make_up");
          } else{
            this.$set(this.formVal[idx], "results_status", "fail");
          }
        }
      }
    },
    levelBScore(idx) {
      const item = this.formVal[idx];
      const arr = this.formVal[idx].scoreArr;
      let score = 0;
      let exam1, exam2, exam3, theory, theory1, oral,maek_up_exam,zuoye;
      arr.map((item) => {
        if (item.achievement_subject_des.includes("实践考试一")) {
          exam1 = Number(item.achievement_score);
          score += item.achievement_score * item.achievement_subject_weight;
        }
        if (item.achievement_subject_des.includes("实践考试二")) {
          exam2 = Number(item.achievement_score);
          score += item.achievement_score * item.achievement_subject_weight;
        }
        if (item.achievement_subject_des.includes("实践考试三")) {
          exam3 = Number(item.achievement_score);
          score += item.achievement_score * item.achievement_subject_weight;
        }
        if (item.achievement_subject_des.includes("一般理论考试")) {
          theory = Number(item.achievement_score);
          score += item.achievement_score * item.achievement_subject_weight;
        }
        if (item.achievement_subject_des.includes("专项理论考试")) {
          theory1 = Number(item.achievement_score);
          score += item.achievement_score * item.achievement_subject_weight;
        }
        if (item.achievement_subject_des.includes("演讲考试")) {
          oral = Number(item.achievement_score);
          score += item.achievement_score * item.achievement_subject_weight;
        }
        if (item.achievement_subject_des.includes("作业考试")) {
          zuoye = Number(item.achievement_score);
          score += item.achievement_score * item.achievement_subject_weight;
        }
        if (item.achievement_subject_des.includes("实践考核补考成绩")) {
          maek_up_exam = Number(item.achievement_score);
        }
      });
      const all_empty = arr.every((v) => {
        return v.achievement_score === "";
      });
      if (all_empty) {
        this.$set(item, "results_status", "");
      }
      else if (maek_up_exam){
        if (maek_up_exam ===70){
          this.$set(this.formVal[idx], "results_status", "pass");
        }else{
          this.$set(this.formVal[idx], "results_status", "fail");
        }
      } else{
        if (exam1 || exam2 || exam3 || theory || theory1 || oral || zuoye){
          score = score / 100;
          let average= score.toFixed(2);// 2023.02.27修改，保留两个小数
          this.$set(this.formVal[idx], "practice_avg_points", average);
        }else{
          this.$set(this.formVal[idx], "practice_avg_points", '');
        }
        let tempArr = [exam1, exam2, exam3].filter((i) => {
          return i >= 70;
        });
        let tempArr1 = [exam1, exam2, exam3].filter((i) => {
          return i >= 42;
        });
        let tempArr2=[theory, theory1,oral,zuoye].filter((i) =>{
          return i >= 60
        });
        if (tempArr.length >= 2 && tempArr2.length === 4 &&  tempArr1.length === 3) {
          this.$set(this.formVal[idx], "results_status", "pass");
        } else {
          if (tempArr2.length!==4){
            this.$set(this.formVal[idx], "results_status", "fail");
          }
          else if (tempArr1.length >= 2 && tempArr.length>=1){
            this.$set(this.formVal[idx], "results_status", "practice_make_up");
          } else{
            this.$set(this.formVal[idx], "results_status", "fail");
          }
      }
      }
    },
    levelCScore(idx) {
      const arr = this.formVal[idx].scoreArr;
      let exam1, exam2, sum, theory, rule,examNew,theoryNew,oralNew;
      let score = 0;
      let scoreRule = "";
      
      arr.map((item) => {
        if (item.achievement_subject_des.includes("实践考试一")) {
          exam1 = Number(item.achievement_score);
        }
        if (item.achievement_subject_des.includes("实践考试二")) {
          exam2 = Number(item.achievement_score);
        }
        if (item.achievement_subject_des.includes("实践考试三")) {
          sum = Number(item.achievement_score);
        }
        if (item.achievement_subject_des.includes("理论课考试")) {
          theory = Number(item.achievement_score);
        }
        if (item.achievement_subject_des.includes("竞赛规则考试")) {
          rule = Number(item.achievement_score);
        }
        if (!item.achievement_subject_des.includes("踢球能力") && !item.achievement_subject_des.includes("是否具备比赛能力")) {
          score += item.achievement_score * item.achievement_subject_weight;
        }
  
        if (item.achievement_subject_id === 85) { // 新版实践考试 2024年7月修改
          scoreRule = "new";
          examNew = Number(item.achievement_score);
        }
  
        if (item.achievement_subject_id === 86) { // 新版理论考试 2024年7月修改
          scoreRule = "new";
          theoryNew = Number(item.achievement_score);
        }
  
        if (item.achievement_subject_id === 87) { // 新版口试 2024年7月修改
          scoreRule = "new";
          oralNew = Number(item.achievement_score);
        }
        
      });
      score = score / 100;
      const all_empty = arr.every((v) => {
        return v.achievement_score === "";
      });
      if (all_empty) {
        this.$set(this.formVal[idx], "total_points", "");
      }
      else if (score === 0) {
        this.$set(this.formVal[idx], "total_points", 0);
      } else {
        score = score.toFixed(2); // 2023.02.27修改，保留两个小数
        this.$set(this.formVal[idx], "total_points", score);
      }
      // 2024年新规则 ：
      /* 1.实践考试由三次变为一次，满分100分，及格70分，总成绩占比70%。
         2.理论考试保持一次不变，满分100分，及格60分，总成绩占比15%。
         3.取消竞赛规则考试，增加口试，满分100分，及格60分，总成绩占比15%。
         4.增加课堂笔记一项，只判断是否提交，讲师需勾选是或者否，若未提交则不允许参加考试。
         5.踢球能力改为是否具备比赛能力，讲师需勾选是或者否。
         6.增加补考环节，三项考试中任意一项不及格可在得知成绩后满六个月参加一次补考。
         7.三项考试中有两项及以上不及格则为未通过。
         8.总成绩不影响学员是否能通过考核，总成绩≥75分可优先录取下一级别课程。*/
      if(scoreRule === 'new'){
        let tempArr=[];
        let make = "";
        if(examNew < 70){
          tempArr.push(examNew);
          make = "practice_make_up";
        }
        if(theoryNew < 60){
          tempArr.push(theoryNew);
          make = "theory_make_up";
        }
        if(oralNew < 60){
          tempArr.push(oralNew);
          make = "oral_make_up";
        }
        if (examNew >= 70 && theoryNew >= 60 && oralNew >= 60) {
          this.$set(this.formVal[idx], "results_status", "pass");
        } else if(tempArr.length === 1){
          this.$set(this.formVal[idx], "results_status", make);
        }else{
          this.$set(this.formVal[idx], "results_status", "fail");
        }
      }else{// 兼容老版本的规则 可能不太会用到
        let tempArr = [exam1, exam2, sum].filter((i) => {
          return i >= 70;
        });
        if (tempArr.length >= 2 && theory >= 60 && rule >= 80) {
          this.$set(this.formVal[idx], "results_status", "pass");
        } else {
          this.$set(this.formVal[idx], "results_status", "fail");
        }
      }
      
    },
    levelDScore(idx) {
      const item = this.formVal[idx];
      const arr = item.scoreArr;
      let exam, theory;
      let score = 0;
      let flagArr = [];
      arr.map((v) => {
        if (!v.achievement_subject_des.includes("踢球能力")  && !v.achievement_subject_des.includes("是否具备比赛能力")) {
          flagArr.push(v.achievement_score);
          score += v.achievement_score * v.achievement_subject_weight;
        }
  
        if (v.achievement_subject_des.includes("实践课考试")) {
          exam = Number(v.achievement_score);
        }
        if (v.achievement_subject_des.includes("理论课考试")) {
          theory = Number(v.achievement_score);
        }
        
      });
      score = score / 100;
      const all_empty = arr.every((v) => {
        return v.achievement_score === "";
      });
      if (all_empty) {
        this.$set(item, "total_points", "");
        this.$set(item, "results_status", "");
      }
      else if (score === 0) {
        this.$set(item, "total_points", 0);
        this.$set(item, "results_status", "fail");
      } else {
        score = score.toFixed(2); // 2023.02.27修改，保留两个小数
        this.$set(item, "total_points", score);
        flagArr.push(score);
        
        // 2024-08-20修改 实践考试>= 70 理论考试>=60
        if(exam >=70 && theory >= 60){
          this.$set(item, "results_status", "pass")
        }else{
          this.$set(item, "results_status", "fail")
        }
        
//        const flag = flagArr.every((el) => {
//          return Number(el) >= 60;
//        });
//        flag
//          ? this.$set(item, "results_status", "pass")
//          : this.$set(item, "results_status", "fail");
      }
    },
    levelEarlyScore(idx) {
      // 初级班 （五人制） 仅处理实践考核 理论考核
      const item = this.formVal[idx];
      const arr = item.scoreArr;
      const all_empty = arr.every((v) => {
        return v.achievement_score === "";
      });
      if (all_empty) {
        this.$set(item, "results_status", "");
      }else {
        let practice = true,theory = true, is_empty = false , fail = false ;
        let active_subject_score  = 0;  // 实践课成绩
        let pass_level = '';
        let pass_level_C = false; // 目前 理论补考通过的 指定为通过C
        arr.map((v) => {
          if(v.achievement_subject_des.includes('实践考核') ) {
            active_subject_score = v.achievement_score;
            if(!v.achievement_score || v.achievement_score < 70) {
              practice = false
            } else if(v.achievement_score === '') {
                is_empty = true
            }
          }
          if(v.achievement_subject_des.includes('理论考核')) {
            if(!v.achievement_score || v.achievement_score < 60) {
              theory = false
            } else if(v.achievement_score === '') {
                is_empty = true
            }
          }
          if(v.achievement_subject_des.includes('理论考核补考成绩')) {
            if(!v.achievement_score || v.achievement_score < 60) {
              fail = true
            } else if(v.achievement_score === '') {
                is_empty = true
            }
            
            if(v.achievement_score > 59){
              pass_level_C = true;
            }
          }
        });
        // is_empty: true 存在空值；
        // status_flag： true 成绩通过；
        if(!is_empty && practice && theory) {  // 学员成绩通过
          if(active_subject_score >= 80) {
            pass_level = 'A';
          } else if(active_subject_score >= 75) {
            pass_level = 'B';
          } else if(active_subject_score >= 70) {
            pass_level = 'C';
          } else {
            pass_level = ''
          }
        }
        if(pass_level_C){
          pass_level = 'C';
        }
        let result_status = "";
        if(practice && theory){
          result_status = "pass";
        }else if(practice && !theory){
          result_status = "semi_pass";
        }else{
          result_status = "fail";
        }
        if(fail){
          result_status = "fail";
        }
        this.$set(item, "results_status", result_status);
        this.$set(item, "results_level", pass_level);
      }
    },
    levelL1Score(idx) {
      // L1班 （五人制） 仅处理实践考核 理论考核 规则考试
      const item = this.formVal[idx];
      const arr = item.scoreArr;
      const all_empty = arr.every((v) => {
        return v.achievement_score === "";
      });
      if (all_empty) {
        this.$set(item, "results_status", "");
      }else {
        let practice = true,theory = true, is_empty = false ,fail = false ;
        let active_subject_score  = 0;  // 实践课成绩
//        let pass_level = '';
        arr.map((v) => {
          if(v.achievement_subject_des.includes('实践考核') ) {
            active_subject_score = v.achievement_score;
            if(!v.achievement_score || v.achievement_score < 70) {
              practice = false
            } else if(v.achievement_score === '') {
                is_empty = true
            }
          }
          if(v.achievement_subject_des.includes('基础理论')) {
            if(!v.achievement_score || v.achievement_score < 60) {
              theory = false
            } else if(v.achievement_score === '') {
                is_empty = true
            }
          }
          if(v.achievement_subject_des.includes('专项理论')) {
            if(!v.achievement_score || v.achievement_score < 60) {
              theory = false
            } else if(v.achievement_score === '') {
              is_empty = true
            }
          }
          if(v.achievement_subject_des.includes('比赛规则')) {
            if(!v.achievement_score || v.achievement_score < 60) {
              theory = false
            } else if(v.achievement_score === '') {
              is_empty = true
            }
          }
          if(v.achievement_subject_des.includes('理论考核补考成绩')) {
            if(!v.achievement_score || v.achievement_score < 60) {
              fail = true
            } else if(v.achievement_score === '') {
              is_empty = true
            }
          }
        });
        // is_empty: true 存在空值；
        // status_flag： true 成绩通过；
//        if(!is_empty && states_flag) {  // 学员成绩通过
//          if(active_subject_score >= 90) {
//            pass_level = 'A';
//          } else if(active_subject_score >= 80) {
//            pass_level = 'B';
//          } else if(active_subject_score >= 72) {
//            pass_level = 'C';
//          } else if(active_subject_score >= 70) {
//            pass_level = 'D';
//          } else {
//            pass_level = ''
//          }
//        }
        let result_status = "";
        if(practice && theory){
          result_status = "pass";
        }else if(practice && !theory){
          result_status = "semi_pass";
        }else{
          result_status = "fail";
        }
        if(fail){
          result_status = "fail";
        }
        this.$set(item, "results_status", result_status);
//        this.$set(item, "results_level", pass_level);
      }
    },
    levelL2Score(idx) {
      // L2班 （五人制） 两次理论考试及格分数均为 60 分。
      //  两次实践考试及格分数均为 70 分。
      const item = this.formVal[idx];
      const arr = item.scoreArr;
      const all_empty = arr.every((v) => {
        return v.achievement_score === "";
      });
      if (all_empty) {
        this.$set(item, "results_status", "");
      }else {
        let practice = true,theory = true, is_empty = false,fail = false ;
        let active_subject_score  = 0;  // 实践课成绩
//        let pass_level = '';
        arr.map((v) => {
          if(v.achievement_subject_des.includes('实践考核一') ) {
            active_subject_score = v.achievement_score;
            if(!v.achievement_score || v.achievement_score < 70) {
              practice = false
            } else if(v.achievement_score === '') {
                is_empty = true
            }
          }
          if(v.achievement_subject_des.includes('实践考核二') ) {
            active_subject_score = v.achievement_score;
            if(!v.achievement_score || v.achievement_score < 70) {
              practice = false
            } else if(v.achievement_score === '') {
                is_empty = true
            }
          }
          if(v.achievement_subject_des.includes('基础理论')) {
            if(!v.achievement_score || v.achievement_score < 60) {
              theory = false
            } else if(v.achievement_score === '') {
                is_empty = true
            }
          }
          if(v.achievement_subject_des.includes('专项理论')) {
            if(!v.achievement_score || v.achievement_score < 60) {
              theory = false
            } else if(v.achievement_score === '') {
              is_empty = true
            }
          }
          if(v.achievement_subject_des.includes('理论考核补考成绩')) {
            if(!v.achievement_score || v.achievement_score < 60) {
              fail = true
            } else if(v.achievement_score === '') {
              is_empty = true
            }
          }
        });
        let result_status = "";
        if(practice && theory){
          result_status = "pass";
        }else if(practice && !theory){
          result_status = "semi_pass";
        }else{
          result_status = "fail";
        }
        if(fail){
          result_status = "fail";
        }
        this.$set(item, "results_status", result_status);
      }
    },
    levelL3Score(idx) {
      // L3班 （五人制）
      // 三次理论考试及格分数均为 60 分。
      //  三次实践考试及格分数均为 70 分。
      const item = this.formVal[idx];
      const arr = item.scoreArr;
      const all_empty = arr.every((v) => {
        return v.achievement_score === "";
      });
      if (all_empty) {
        this.$set(item, "results_status", "");
      }else {
        let practice = true,theory = true,  is_empty = false,fail = false;
        let active_subject_score  = 0;  // 实践课成绩
//        let pass_level = '';
        arr.map((v) => {
          if(v.achievement_subject_des.includes('实践考核一') ) {
            active_subject_score = v.achievement_score;
            if(!v.achievement_score || v.achievement_score < 70) {
              practice = false
            } else if(v.achievement_score === '') {
                is_empty = true
            }
          }
          if(v.achievement_subject_des.includes('实践考核二') ) {
            active_subject_score = v.achievement_score;
            if(!v.achievement_score || v.achievement_score < 70) {
              practice = false
            } else if(v.achievement_score === '') {
                is_empty = true
            }
          }
          if(v.achievement_subject_des.includes('实践考核三') ) {
            active_subject_score = v.achievement_score;
            if(!v.achievement_score || v.achievement_score < 70) {
              practice = false
            } else if(v.achievement_score === '') {
                is_empty = true
            }
          }
          if(v.achievement_subject_des.includes('基础理论')) {
            if(!v.achievement_score || v.achievement_score < 60) {
              theory = false
            } else if(v.achievement_score === '') {
                is_empty = true
            }
          }
          if(v.achievement_subject_des.includes('专项理论')) {
            if(!v.achievement_score || v.achievement_score < 60) {
              theory = false
            } else if(v.achievement_score === '') {
              is_empty = true
            }
          }
          if(v.achievement_subject_des.includes('口试')) {
            if(!v.achievement_score || v.achievement_score < 60) {
              theory = false
            } else if(v.achievement_score === '') {
              is_empty = true
            }
          }
          if(v.achievement_subject_des.includes('理论考核补考成绩')) {
            if(!v.achievement_score || v.achievement_score < 60) {
              fail = true
            } else if(v.achievement_score === '') {
              is_empty = true
            }
          }
        });
        let result_status = "";
        if(practice && theory){
          result_status = "pass";
        }else if(practice && !theory){
          result_status = "semi_pass";
        }else{
          result_status = "fail";
        }
        if(fail){
          result_status = "fail";
        }
        this.$set(item, "results_status", result_status);
      }
    },
    levelF1Score(idx) {
      const item = this.formVal[idx];
      const arr = this.formVal[idx].scoreArr;
      let exam1, exam2, theory,maek_up_exam;
      let score = 0;
      arr.map((item) => {
        if (item.achievement_subject_des.includes("实践考试一")) {
          exam1 = Number(item.achievement_score);
          score += item.achievement_score * item.achievement_subject_weight;
        }
        if (item.achievement_subject_des.includes("实践考试二")) {
          exam2 = Number(item.achievement_score);
          score += item.achievement_score * item.achievement_subject_weight;
        }
        if (item.achievement_subject_des.includes("理论课考试")) {
          theory = Number(item.achievement_score);
          score += item.achievement_score * item.achievement_subject_weight;
        }
        if (item.achievement_subject_des.includes("实践考核补考成绩")) {
          maek_up_exam = Number(item.achievement_score);
        }
        
      });
      score = score / 100;
      const all_empty = arr.every((v) => {
        return v.achievement_score === "";
      });
      if (all_empty) {
        this.$set(item, "total_points", "");
        this.$set(item, "results_status", "");
      }
      else if (maek_up_exam){
        if (maek_up_exam ===70){
          this.$set(this.formVal[idx], "results_status", "pass");
        }else{
          this.$set(this.formVal[idx], "results_status", "fail");
        }
      }else {
        if (score === 0) {
          this.$set(this.formVal[idx], "total_points", 0);
        } else {
          score = score.toFixed(2); // 2023.02.27修改，保留两个小数
          this.$set(this.formVal[idx], "total_points", score);
        }
        let tempArr = [exam1, exam2].filter((i) => {
          return i >= 70;
        });
        let tempArr2=[theory].filter((i) =>{
          return i >= 60
        });
        if (tempArr.length === 2 &&  tempArr2.length === 1) {
          this.$set(this.formVal[idx], "results_status", "pass");
        } else {
          if (tempArr2.length!==1){ // 理论 如果不是>=60 直接就不通过了
            this.$set(this.formVal[idx], "results_status", "fail");
          }
          else if (tempArr.length >= 1){
            // 如有1次未及格，需实践课考试补考
            this.$set(this.formVal[idx], "results_status", "practice_make_up");
          } else{
            this.$set(this.formVal[idx], "results_status", "fail");
          }
        }
      }
    },
    levelF2Score(idx) {
      const item = this.formVal[idx];
      const arr = this.formVal[idx].scoreArr;
      let exam1, exam2, theory,maek_up_exam;
      let score = 0;
      arr.map((item) => {
        if (item.achievement_subject_des.includes("实践考试一")) {
          exam1 = Number(item.achievement_score);
          score += item.achievement_score * item.achievement_subject_weight;
        }
        if (item.achievement_subject_des.includes("实践考试二")) {
          exam2 = Number(item.achievement_score);
          score += item.achievement_score * item.achievement_subject_weight;
        }
        if (item.achievement_subject_des.includes("理论课考试")) {
          theory = Number(item.achievement_score);
          score += item.achievement_score * item.achievement_subject_weight;
        }
        if (item.achievement_subject_des.includes("实践考核补考成绩")) {
          maek_up_exam = Number(item.achievement_score);
        }
        
      });
      score = score / 100;
      const all_empty = arr.every((v) => {
        return v.achievement_score === "";
      });
      if (all_empty) {
        this.$set(item, "total_points", "");
        this.$set(item, "results_status", "");
      }
      else if (maek_up_exam){
        if (maek_up_exam ===70){
          this.$set(this.formVal[idx], "results_status", "pass");
        }else{
          this.$set(this.formVal[idx], "results_status", "fail");
        }
      }else {
        if (score === 0) {
          this.$set(this.formVal[idx], "total_points", 0);
        } else {
          score = score.toFixed(2); // 2023.02.27修改，保留两个小数
          this.$set(this.formVal[idx], "total_points", score);
        }
        let tempArr = [exam1, exam2].filter((i) => {
          return i >= 70;
        });
        let tempArr2=[theory].filter((i) =>{
          return i >= 60
        });
        if (tempArr.length === 2 &&  tempArr2.length === 1) {
          this.$set(this.formVal[idx], "results_status", "pass");
        } else {
          if (tempArr2.length!==1){ // 理论 如果不是>=60 直接就不通过了
            this.$set(this.formVal[idx], "results_status", "fail");
          }
          else if (tempArr.length >= 1){
            // 如有1次未及格，需实践课考试补考
            this.$set(this.formVal[idx], "results_status", "practice_make_up");
          } else{
            this.$set(this.formVal[idx], "results_status", "fail");
          }
        }
      }
    },
    
    levelGCScore(idx) {
      const item = this.formVal[idx];
      const arr = item.scoreArr;
      let score = 0;
      let flagArr = [];
      arr.map((v) => {
        if (!v.achievement_subject_des.includes("踢球能力")) {
          flagArr.push(v.achievement_score);
          score += v.achievement_score * v.achievement_subject_weight;
        }
      });
      score = score / 100;
      const all_empty = arr.every((v) => {
        return v.achievement_score === "";
      });
      if (all_empty) {
        this.$set(item, "total_points", "");
        this.$set(item, "results_status", "");
      }
      else if (score === 0) {
        this.$set(item, "total_points", 0);
        this.$set(item, "results_status", "fail");
      } else {
        score = score.toFixed(2); // 2023.02.27修改，保留两个小数
        this.$set(item, "total_points", score);
        flagArr.push(score);
        const flag = flagArr.every((el) => {
          return Number(el) >= 60;
        });
        flag
          ? this.$set(item, "results_status", "pass")
          : this.$set(item, "results_status", "fail");
      }
    },
    levelGAScore(idx) {
      const item = this.formVal[idx];
      const arr = this.formVal[idx].scoreArr;
      let exam1, exam2, theory,maek_up_exam;
      let score = 0;
      arr.map((item) => {
        if (item.achievement_subject_des.includes("实践考试一")) {
          exam1 = Number(item.achievement_score);
          score += item.achievement_score * item.achievement_subject_weight;
        }
        if (item.achievement_subject_des.includes("实践考试二")) {
          exam2 = Number(item.achievement_score);
          score += item.achievement_score * item.achievement_subject_weight;
        }
        if (item.achievement_subject_des.includes("理论课考试")) {
          theory = Number(item.achievement_score);
          score += item.achievement_score * item.achievement_subject_weight;
        }
        if (item.achievement_subject_des.includes("实践考核补考成绩")) {
          maek_up_exam = Number(item.achievement_score);
        }
      
      });
      score = score / 100;
      const all_empty = arr.every((v) => {
        return v.achievement_score === "";
      });
      if (all_empty) {
        this.$set(item, "total_points", "");
        this.$set(item, "results_status", "");
      }
      else if (maek_up_exam){
        if (maek_up_exam ===70){
          this.$set(this.formVal[idx], "results_status", "pass");
        }else{
          this.$set(this.formVal[idx], "results_status", "fail");
        }
      }else {
        if (score === 0) {
          this.$set(this.formVal[idx], "total_points", 0);
        } else {
          score = score.toFixed(2); // 2023.02.27修改，保留两个小数
          this.$set(this.formVal[idx], "total_points", score);
        }
        let tempArr = [exam1, exam2].filter((i) => {
          return i >= 70;
        });
        let tempArr2=[theory].filter((i) =>{
          return i >= 60
        });
        if (tempArr.length === 2 &&  tempArr2.length === 1) {
          this.$set(this.formVal[idx], "results_status", "pass");
        } else {
          if (tempArr2.length!==1){ // 理论 如果不是>=60 直接就不通过了
            this.$set(this.formVal[idx], "results_status", "fail");
          }
          else if (tempArr.length >= 1){
            // 如有1次未及格，需实践课考试补考
            this.$set(this.formVal[idx], "results_status", "practice_make_up");
          } else{
            this.$set(this.formVal[idx], "results_status", "fail");
          }
        }
      }
    },
    levelGBScore(idx) {
      const item = this.formVal[idx];
      const arr = this.formVal[idx].scoreArr;
      let exam1, exam2, theory,maek_up_exam;
      let score = 0;
      arr.map((item) => {
        if (item.achievement_subject_des.includes("实践考试一")) {
          exam1 = Number(item.achievement_score);
          score += item.achievement_score * item.achievement_subject_weight;
        }
        if (item.achievement_subject_des.includes("实践考试二")) {
          exam2 = Number(item.achievement_score);
          score += item.achievement_score * item.achievement_subject_weight;
        }
        if (item.achievement_subject_des.includes("理论课考试")) {
          theory = Number(item.achievement_score);
          score += item.achievement_score * item.achievement_subject_weight;
        }
        if (item.achievement_subject_des.includes("实践考核补考成绩")) {
          maek_up_exam = Number(item.achievement_score);
        }
      
      });
      score = score / 100;
      const all_empty = arr.every((v) => {
        return v.achievement_score === "";
      });
      if (all_empty) {
        this.$set(item, "total_points", "");
        this.$set(item, "results_status", "");
      }
      else if (maek_up_exam){
        if (maek_up_exam ===70){
          this.$set(this.formVal[idx], "results_status", "pass");
        }else{
          this.$set(this.formVal[idx], "results_status", "fail");
        }
      }else {
        if (score === 0) {
          this.$set(this.formVal[idx], "total_points", 0);
        } else {
          score = score.toFixed(2); // 2023.02.27修改，保留两个小数
          this.$set(this.formVal[idx], "total_points", score);
        }
        let tempArr = [exam1, exam2].filter((i) => {
          return i >= 70;
        });
        let tempArr2=[theory].filter((i) =>{
          return i >= 60
        });
        if (tempArr.length === 2 &&  tempArr2.length === 1) {
          this.$set(this.formVal[idx], "results_status", "pass");
        } else {
          if (tempArr2.length!==1){ // 理论 如果不是>=60 直接就不通过了
            this.$set(this.formVal[idx], "results_status", "fail");
          }
          else if (tempArr.length >= 1){
            // 如有1次未及格，需实践课考试补考
            this.$set(this.formVal[idx], "results_status", "practice_make_up");
          } else{
            this.$set(this.formVal[idx], "results_status", "fail");
          }
        }
      }
    },
    levelScoreEducation(idx) {
      // 继续教育 优良中差 差是不通过
      const item = this.formVal[idx];
      const arr = item.scoreArr;
      const all_empty = arr.every((v) => {
        return v.achievement_score === "";
      });
      if (all_empty) {
        this.$set(item, "results_status", "");
      }else {
        let states_flag = true, is_empty = false;
        let active_subject_score  = 0;
        //        let pass_level = '';
        arr.map((v) => {
          // 教案考核
          if(v.achievement_subject_id === 200 ) {
            active_subject_score = v.achievement_score;
            if(!v.achievement_score || v.achievement_score === '差') {
              states_flag = false
            } else if(v.achievement_score === '') {
              is_empty = true
            }
          }
        });
        this.$set(item, "results_status", is_empty ? '' : states_flag ? 'pass' : 'fail');
      }
    },
    levelScoreOther(idx) {
      console.error('班级冗余，请增加额外成绩处理策略')
    },
    getResult() {
      if (['D'].includes(this.classInfo.class_level) || ['continue_education','teacher_train','goalkeeper_education'].includes(this.classInfo.class_train_type)){
        let pass = 0, fail = 0 ,semi_pass = 0;
        this.formVal.map((item) => {
          item.results_status === "pass" && (pass++);
          item.results_status === "fail" && (fail++);
          item.results_status === "semi_pass" && (semi_pass++);
        });
        this.passNum = pass;
        this.semi_pass = semi_pass;
        this.showTotal = Boolean(pass + fail + semi_pass === this.formVal.length);
      } else if (['C'].includes(this.classInfo.class_level)){
        let pass = 0, fail = 0 ,theory_make_up = 0,oral_make_up = 0,practice_make_up = 0;
        this.formVal.map((item) => {
          item.results_status === "pass" && (pass++);
          item.results_status === "fail" && (fail++);
          item.results_status === "theory_make_up" && (theory_make_up++);
          item.results_status === "oral_make_up" && (oral_make_up++);
          item.results_status === "practice_make_up" && (practice_make_up++);
        });
        this.passNum = pass;
        this.theory_make_up = theory_make_up;
        this.oral_make_up = oral_make_up;
        this.practice_make_up = practice_make_up;
        this.showTotal = Boolean(pass + fail + theory_make_up + oral_make_up + practice_make_up === this.formVal.length);
      } else if (['L1','L2','L3'].includes(this.classInfo.class_level)){
        let pass = 0, fail = 0 ,semi_pass = 0;
        let stuList=this.formVal.filter((item)=>{
          return item.enroll_type!=='semi_pass_make_up'
        })
        this.commonStuList = stuList;
        this.commonStuList.map((item) => {
          item.results_status === "pass" && (pass++);
          item.results_status === "fail" && (fail++);
          item.results_status === "semi_pass" && (semi_pass++);
        });
        this.passNum = pass;
        this.semi_pass = semi_pass;
        this.showTotal = Boolean(pass + fail + semi_pass === this.commonStuList.length);
      } else if(this.classInfo.class_level==='early' ) {
        let pass = 0, fail = 0,semi_pass = 0, l1Num = 0, activeExam = 0, onlyEarly = 0;
        let stuList=this.formVal.filter((item)=>{
          return item.enroll_type!=='semi_pass_make_up'
        })
        this.commonStuList = stuList;
        this.commonStuList.forEach((item) => {
          (item.results_status === "pass")  && (pass++);
          (item.results_status === "fail") && (fail++);
          (item.results_status === "semi_pass") && (semi_pass++);
          (item.results_level === 'A') && (l1Num++);
          (item.results_level === 'B') && (activeExam++);
          (item.results_level === 'C') && (onlyEarly++);
        });
        this.fail=fail;
        this.passNum = pass;
        this.semi_pass = semi_pass;
        this.l1Num = l1Num;
        this.activeExam = activeExam;
        this.onlyEarly = onlyEarly;
        this.showTotal = Boolean(pass + fail + semi_pass === this.commonStuList.length);
      }else if(this.classInfo.class_train_type==='physical_train' ) { // 体能等级培训
        let pass = 0, fail = 0,exam=0;
        let stuList=this.formVal.filter((item)=>{
          return item.enroll_type==='physical_train'
        })
        this.commonStuList=stuList;
        this.commonStuList.map((item) => {
          (item.results_status === "pass" && item.enroll_type==='physical_train')  && (pass++);
          (item.results_status === "fail" && item.enroll_type ==='physical_train' ) && (fail++);
          (item.results_status === "practice_make_up" && item.enroll_type ==='physical_train' ) && (exam++);
        });
        this.fail=fail;
        this.passNum = pass;
        this.showTotal = Boolean(pass + fail + exam === this.commonStuList.length);
      }else if(this.classInfo.class_train_type==='goalkeeper_train' ) { // 体能等级培训
        let pass = 0, fail = 0,exam=0;
        let stuList=this.formVal.filter((item)=>{
          return item.enroll_type==='goalkeeper_train'
        })
        this.commonStuList=stuList;
        this.commonStuList.map((item) => {
          (item.results_status === "pass" && item.enroll_type==='goalkeeper_train')  && (pass++);
          (item.results_status === "fail" && item.enroll_type ==='goalkeeper_train' ) && (fail++);
          (item.results_status === "practice_make_up" && item.enroll_type ==='goalkeeper_train' ) && (exam++);
        });
        this.fail=fail;
        this.passNum = pass;
        this.showTotal = Boolean(pass + fail + exam === this.commonStuList.length);
      } else{
        let pass = 0, fail = 0,exam=0;
        let stuList=this.formVal.filter((item)=>{
          return item.enroll_type==='common'
        })
        this.commonStuList=stuList;
        this.commonStuList.map((item) => {
          (item.results_status === "pass" && item.enroll_type==='common')  && (pass++);
          (item.results_status === "fail" && item.enroll_type ==='common' ) && (fail++);
          (item.results_status === "practice_make_up" && item.enroll_type ==='common' ) && (exam++);
        });
        this.fail=fail;
        this.passNum = pass;
        this.showTotal = Boolean(pass + fail + exam === this.commonStuList.length);
      }
    },
    checkVal() {
      let err = false;
      this.formVal.map((item) => {
        item.scoreArr.map((v) => {
          if (v.achievement_score === "") {
            v.err = true;
            err = true;
          }
        });
      });
      return err;
    },
    checkValEducation() {
      let err = false;
      this.formVal.map((item) => {
        if (item.results_status === '') {
          item.err = true;
          err = true;
        }
      });
      return err;
    },
    async submitScore(flag, bool) {
      let operation_msg_id = '0';
      let save_status = '';
      this.loading = true;
      // 点保存了  都保存一下信息
      // 把头像字段给清空了 不然数据太长会出错
      this.formVal.map(item => {
        item.user_img = ''
        return item
      })
      if(flag === 'audit'){
        save_status = 'audit';
      }
      const submitData = {
        c_id:this.c_id,
        student_score_data:JSON.stringify(this.formVal),
        operation_type:'save_score'
      }
      await operationMsgSave(submitData).then(({data}) => {
        operation_msg_id = data.result.operationMsg.msg_id;
      })
      uploadScore({c_id: this.c_id, student_score_data: JSON.stringify(this.formVal),operation_msg_id:operation_msg_id,save_status:save_status})
        .then(({data}) => {
          this.loading = false;
          if (Number(data.status) === 0) {
            if (flag === "back") {
              this.$set(this.backWarn, "flag", bool);
              this.$message.success("暂时保存成功");
              this.$router.go(-1);
            }
            if (flag === "next") {
              this.$set(this.nextWarn, "flag", bool);
              this.$message.success("成绩保存成功");
              const routerPath = this.isFive ? 'upload_score_report_five' : 'class_report'
              this.$router.push({
                path: routerPath,
                query: {
                  c_id: this.c_id
                }
              });
            }
            if (flag === "audit") {
              this.$set(this.submitUploadEducationWarn, "flag", bool);
              this.$message.success("成绩提交成功");
              this.$router.go(-1);
            }
          } else {
            throw new Error(data.msg || "提交失败");
          }
        })
        .catch((err) => {
          this.loading = false;
          this.repeatSubmit = false;
          console.error(err);
        });
    },
    userImgError(idx) {
      this.$set(this.formVal[idx], "user_img", this.User);
    },
    goBack() {
      this.$set(this.backWarn, "flag", true);
    },
    hideBackTips(bool, flag) {
      this.$set(this.backWarn, "flag", bool);
      if(flag) {
        this.$router.go(-1);
      }
    },
    nextStep() {
      const err = this.checkVal();
      let isnoticeCheckPass = true;
      if(this.isFive) {
        isnoticeCheckPass = this.validateFormVal();
      }
      if((!err && !this.isFive) || (!err && this.isFive && isnoticeCheckPass)) {
        this.$set(this.nextWarn, "flag", true);
        return false;
      }
      this.$message({
        type: "error",
        message: "请完善成绩信息"
      });
    },
    hideNextTips(bool, flag) {
      if (this.repeatSubmit) return;
      if (flag) {
        this.repeatSubmit = true;
        this.submitScore("next", bool);
      } else {
        this.$set(this.nextWarn, "flag", bool);
      }
    },
    tempUpload() {
      this.$set(this.uploadWarn, "flag", true);
    },
    nextStepEducation(){
      const err = this.checkValEducation();
      if(!err) {
        this.$set(this.nextWarn, "flag", true);
        return false;
      }
      this.$message({
        type: "error",
        message: "请完善成绩信息"
      });
    },
    submitUploadEducation(){
      const err = this.checkValEducation();
      if(!err) {
        this.$set(this.submitUploadEducationWarn, "flag", true);
        return false;
      }
      this.$message({
        type: "error",
        message: "请完善成绩信息"
      });
    },
    
    // 继续教育的提交
    hideSubmitUploadEducationTips(bool, flag) {
      
      if (this.repeatSubmit) return;
      if (flag) {
        this.repeatSubmit = true;
        this.submitScore("audit", bool);
      } else {
        this.$set(this.submitUploadEducationWarn, "flag", bool);
      }
      
    },
    hideUploadTips(bool, flag) {
      if(this.repeatSubmit) return;
      if(flag) {
        this.repeatSubmit = true;
        this.submitScore("back", bool);
      } else {
        this.$set(this.uploadWarn, "flag", bool);
      }
    },
    previewScore() {
      this.showPreScore = true;
    },
    viewDetail(uid) {
      this.stuUid = uid;
      this.ifDiaShow = true;
    },
  }
}
